import { getInitials } from '@/utils/userNames'
import { GetUserType } from '@orbit/api-types'
import React from 'react'
import { MemberAvatar } from './MembersSection/MembersSection.styles'

interface Props {
	member: GetUserType | undefined
	size?: 'sm' | 'md'
}

export const Avatar: React.FC<Props> = ({ member, size = 'md' }) => (
	<MemberAvatar $size={size}>
		{member?.profilePicture ? (
			<img src={member.profilePicture} alt={getInitials(member)} />
		) : (
			getInitials(member)
		)}
	</MemberAvatar>
)
